import { PanelType } from '../../../../panels/types';

export const importFunnelPanelType: PanelType = {
  name: 'IMPORT_FUNNEL',
  location: 'left'
};
